import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

import { AssignmentScheduleStateService } from '../assignments/assignment-schedules/services/assignment-schedule-state.service';
import { OpenAssignmentsModalComponent } from '../assignments/components/open-assignments-modal/open-assignments-modal.component';
import { AssignmentTakeoverModel } from '../assignments/models/assignment-takeover.model';
import { AssignmentsOverviewModel } from '../assignments/models/assignments-overview.model';
import { AssignmentStateService } from '../assignments/services/assignment-state.service';
import { HeaderStateService } from '../main/headers/services/header-state.service';
import { ApplicationUser } from '../security/application-user.model';
import { UserAuthorizationService } from '../security/services/user-authorization.service';
import { SponsorsStateService } from '../shared/components/sponsors/services/sponsors-state.service';
import { AssignmentEventTypeEnum } from '../shared/enums/assignment-event-type.enum';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
    private bsModalService = inject(BsModalService);
    private headerStateService = inject(HeaderStateService);
    private sponsorsStateService = inject(SponsorsStateService);
    private authService = inject(UserAuthorizationService);
    protected assignmentsStateService = inject(AssignmentStateService);
    protected assignmentScheduleStateService = inject(AssignmentScheduleStateService);

    assigmentsOverviewModel?: AssignmentsOverviewModel[] = [];
    isLoggedIn: boolean | null = null;
    isStaffOrAdmin: boolean | null = null;

    protected isLoading: boolean = false;

    protected assignmentEventTypes = AssignmentEventTypeEnum;

    constructor() {
        this.headerStateService.showDefaultHeader();
    }
    ngOnDestroy(): void {
        this.sponsorsStateService.hideSponsorFooter();
    }

    ngOnInit(): void {
        this.authService.user$.subscribe(user => {
            this.checkLoginState(user);
        })
    }

    protected async login(rememberLogin: boolean): Promise<void> {
        if (this.isLoading) return;

        try {
            await this.loginInternal(rememberLogin);
        } catch (err) {
            this.isLoading = false;
        }
    }

    private async loginInternal(rememberLogin: boolean): Promise<void> {
        this.isLoading = true;
        const hasSession = await this.authService.hasActiveSession();

        if (hasSession) {
            // User already has a valid session
            await this.authService.loadUserAsync();
            return;
        }

        // Normal login redirect
        this.authService.login(null, rememberLogin);
    }

    logout() {
        this.authService.logout();
    }

    protected openAssignmentClicked(assignment: AssignmentsOverviewModel): void {

        const takeoverAssignment: AssignmentTakeoverModel = {
            assignment: assignment,
            isSuccess: null,
            errorMessage: null
        }

        const takeoverAssignments = [takeoverAssignment];

        const initialState = { takeoverAssignments: takeoverAssignments };
        let modalRef = this.bsModalService.show(OpenAssignmentsModalComponent, {
            ignoreBackdropClick: true,
            initialState
        });
        modalRef!.content!.onSuccess.subscribe((success: boolean) => {
            if (success) {
                this.assignmentsStateService.loadtopThreeNextAssignments();
                this.assignmentsStateService.loadtopThreeOpenAssignments();
            }
        })
    }

    private checkLoginState(applicationUser: ApplicationUser | null): void {
        this.isLoggedIn = applicationUser != null;

        if (this.isLoggedIn) {
            this.isStaffOrAdmin = applicationUser?.isStaffOrAdmin() ?? false;
            this.sponsorsStateService.hideSponsorFooter();

            if (!this.isStaffOrAdmin) return;
            this.assignmentsStateService.loadtopThreeNextAssignments();
            this.assignmentsStateService.loadtopThreeOpenAssignments();
            this.assignmentScheduleStateService.loadUnansweredAssignmentSchedules();
        } else {
            this.sponsorsStateService.showSponsorFooter();
        }

    }
}
